import React, { Component } from 'react'

class Footer extends Component {
  render() {
    return (
      <div className="curriculum-footer">
        <small>RO DOC 3  |  Bohol Island State University  |  www.bisu.edu.ph</small>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/containers/Print/Curriculums/footer.js